import "./brand.css";
import brandImg1 from '../../../assets/images/image1.png';
import brandImg2 from '../../../assets/images/image2.png';
import brandImg3 from '../../../assets/images/image3.png';
import brandImg4 from '../../../assets/images/image4.png';
import brandImg5 from '../../../assets/images/image5.png';   
import brandImg6 from '../../../assets/images/image6.png';
import brandImg7 from '../../../assets/images/image7.png';
import brandImg8 from '../../../assets/images/image8.png';
import brandImg9 from '../../../assets/images/image9.png';
import brandImg10 from '../../../assets/images/image10.png';
import brandImg11 from '../../../assets/images/image11.png';
import brandImg12 from '../../../assets/images/image12.png';
import brandImg13 from '../../../assets/images/image13.png';
import brandImg14 from '../../../assets/images/image14.png';
import brandImg15 from '../../../assets/images/image15.png';
import brandImg16 from '../../../assets/images/image16.png';
import brandImg17 from '../../../assets/images/image17.png';
import brandImg18 from '../../../assets/images/image18.png';
import brandImg19 from '../../../assets/images/image19.jpg';
import brandImg20 from '../../../assets/images/image20.png';

let brandimg = [
    {
        id: 0,
        img: brandImg1,
    },
    {
        id: 1,
        img: brandImg2,
    },
    {
        id: 2,
        img: brandImg3,
    },
    {
        id: 3,
        img: brandImg4,
    },
    {
        id: 4,
        img: brandImg5,
    },
    {
        id: 5,
        img: brandImg6,
    },
    {
        id: 6,
        img: brandImg7,
    },
    {
        id: 7,
        img: brandImg8,
    },
    {
        id: 8,
        img: brandImg9,
    },
    {
        id: 9,
        img: brandImg10,
    },
    {
        id: 10,
        img: brandImg11,
    },
    {
        id: 11,
        img: brandImg12,
    },
    {
        id: 12,
        img: brandImg13,
    },
    {
        id: 13,
        img: brandImg14,
    },
    {
        id: 14,
        img: brandImg15,
    },
    {
        id: 15,
        img: brandImg16,
    },
    {
        id: 16,
        img: brandImg17,
    },
    {
        id: 17,
        img: brandImg18,
    },
    {
        id: 18,
        img: brandImg19,
    },
    {
        id: 19,
        img: brandImg20,
    },
];
export default function Brand() {
    return (
        <div className="brand text-center">
         <div className="container">
            <h2>The brands that made us <b className="d-block">Who We Are</b></h2>
          <div className="brand-row d-flex flex-wrap">
            {brandimg.map((image)=>(
            <div className="brand-col" key={image.id}>
                <img src={image.img} alt="brand" />
            </div>
            ))}
          </div>
         </div>
        </div>
    )
}